module.exports = __webpack_public_path__ + "img/texto-galeria.bda7c1e6.png";